import { AlertCircle } from "lucide-react";
import React from "react";

interface TextInputCompProps {
    rows?: number;
    placeholder?: string;
    className?: string;
    onChangeText: (text: string) => void;
    value: string | number;
    showLabel?: boolean;
    label?: string;
    error?: string | null;
    disabled?: boolean;
    showStar?: boolean;
}

const TextAreaComp: React.FC<TextInputCompProps> = ({
    rows,
    placeholder,
    className = "",
    onChangeText,
    value,
    showLabel = false,
    label,
    error = null,
    disabled,
    showStar }) => {

    const hasError = !!error;
    return (
        <div className="py-2">
            {showLabel && (
                <label className="pb-2 block flex items-center gap-1">
                    <p className="text-md text-mainBrandColor">{label}</p>
                    {showStar && (
                        <p className="text-md text-red-500">*</p>
                    )}
                </label>
            )}
            <div className="relative">
                <textarea
                    placeholder={placeholder}
                    value={value}
                    className={`w-full p-4 rounded-lg text-sm text-logoHeading border border-gray-400 
hover:border-accent 
focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent 
placeholder:text-sm 
${className} 
${disabled
                            ? "opacity-70 cursor-not-allowed bg-gray-200 text-gray-900"
                            : "bg-white cursor-pointer"
                        }
${hasError ? "border-red-500 focus:border-red-500 focus:ring-red-500" : ""}`}
                    rows={rows}
                    onChange={(e) => onChangeText(e.target.value)}
                />
                {hasError && (
                    <AlertCircle
                        size={18}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-red-500"
                    />
                )}
            </div>
        </div>
    );
}

export default TextAreaComp;